import clsx from 'clsx';
import React from 'react';
import Button from '../../basic/button';
import { INavbarIndicatorsProps } from './modal';

const NavbarIndicators = (props: INavbarIndicatorsProps): JSX.Element => {
  return (
    <Button
      data-bs-target={`#${props['target-testid']}`}
      data-bs-slide-to={props.slide}
      className={clsx(
        '!bg-secondary-500 !h-1 xl:!w-xl lg:!w-xl !opacity-100 carousel-indicators-btn',
        {
          active: props.active === 'true',
        }
      )}
      aria-label={`Slide ${props.slide}`}
      border={true}
      data-testid="nav-indicators"
      {...props}
    />
  );
};

export default NavbarIndicators;
